var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterSec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 446.282,
    height: 363.162,
    viewBox: "0 0 446.282 363.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#33233d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.9 -17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M456.182,60.455a187.684,187.684,0,0,1-52.438,14.5A89.246,89.246,0,0,0,443.91,24.194a192.669,192.669,0,0,1-58.017,22.314,91.566,91.566,0,0,0-158.43,62.48,83.652,83.652,0,0,0,2.231,20.641c-75.868-3.347-142.81-40.165-188-95.393C9.342,92.252,45.6,140.228,69.59,156.405c-14.5,0-29.008-4.463-41.281-11.157,0,45.186,31.8,82.562,73.079,90.93-8.926,2.789-29.008,4.463-41.281,1.674,11.715,36.26,45.744,63.037,85.352,63.6-31.24,24.546-76.984,44.07-135.558,37.934a258.079,258.079,0,0,0,140.579,41.281c168.472,0,259.96-139.463,259.96-259.959a82.391,82.391,0,0,0-.558-11.715c18.967-13.946,34.587-30.124,46.3-48.533Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSec);
export default __webpack_public_path__ + "static/media/twitterSec.e0c62ca84b9a174e4fe051609b870bdc.svg";
export { ForwardRef as ReactComponent };